import { FormikErrors } from 'formik';
import { useEffect, useState } from 'react';

import { VALIDATION_CLASS } from 'utils/constants';

export default function useValidation(
  ref: React.RefObject<HTMLFormElement | HTMLDivElement | null>,
  errors: FormikErrors<unknown>,
  submitCount: number,
) {
  const [currentCount, setCurrentCount] = useState(submitCount);

  useEffect(() => {
    if (
      Object.keys(errors)?.length &&
      submitCount > 0 &&
      submitCount !== currentCount
    ) {
      const validationFields = ref?.current?.querySelectorAll(
        `.${VALIDATION_CLASS}`,
      );

      setCurrentCount(submitCount);

      validationFields?.[0]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, ref, submitCount, currentCount]);
}
